// Login.js
import React, { useState } from 'react';
import '../css/Login.css';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin_panel/login`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const result = await response.json();
      console.log("Login response:", result);

      // ✅ Correct and flexible login success condition
      const isLoginSuccess = response.ok && (result.success === true || result.status === "success") && result.message?.toLowerCase().includes("login successful");

      if (isLoginSuccess) {
        const payload = result.data || result;
        Cookies.set('email', payload.user || payload.email || email, { expires: 7 });
        Cookies.set('ec_auth_token', payload.token || payload.session_id, { expires: 7 });
        console.log("Token/Session:", payload.token || payload.session_id);
        Cookies.set('college', payload.college || 'main', { expires: 7 });
        Cookies.set('permissions', JSON.stringify(payload.permissions || []), { expires: 7 });
        Cookies.set('allowed_forms', JSON.stringify(payload.allowed_forms || []), { expires: 7 });

        Swal.fire({
          title: `🎉 Welcome${result.username ? ', ' + result.username : ''}!`,
          html: 'Login successful. Redirecting...',
          icon: 'success',
          confirmButtonText: 'Continue',
          timer: 2500,
          timerProgressBar: true,
        }).then((res) => {
          if (res.isConfirmed || res.dismiss === Swal.DismissReason.timer) {
            onLogin();
            navigate('/forms');
          }
        });

      } else {
        console.warn("⚠️ Login failed but no error thrown");
        Swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: result.error || result.message || 'Invalid email or password.',
        });
        setError(result.error || result.message || 'Login failed');
      }

    } catch (err) {
      console.error("❌ Error during login:", err);
      Swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: 'Something went wrong. Please try again later.',
      });
      setError('Something went wrong.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Login</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email id"
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {/* <div className="forgot-password">
            Lost password? <a href="#">Click here!</a>
          </div> */}
          <div className="button-group">
            {/* <button type="button" className="signup-button" disabled>
              Sign Up
            </button> */}
            <button type="submit" className="login-button" disabled={isSubmitting}>
              {isSubmitting ? 'Logging in...' : 'Login'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;